import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgUserPlus = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#user-plus_svg__a)">
      <path
        fill="currentColor"
        d="M24.501 12.849a.75.75 0 0 1-.75.75h-1.5v1.5a.75.75 0 1 1-1.5 0v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.5v-1.5a.75.75 0 1 1 1.5 0v1.5h1.5a.75.75 0 0 1 .75.75m-10.5 2.032a6.376 6.376 0 1 0-6.74 0c-1.937.634-3.678 1.818-5.079 3.485a.75.75 0 0 0 .569 1.233h15.75a.751.751 0 0 0 .575-1.233c-1.402-1.667-3.144-2.851-5.075-3.485"
      />
    </g>
    <defs>
      <clipPath id="user-plus_svg__a">
        <path fill="currentColor" d="M.5.1h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgUserPlus);
export default ForwardRef;
